import { Component, OnInit } from '@angular/core';
import { StateService } from '../../../core/services/state.service';
import { ModalService } from '../../../core/services/modal.service';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';
import { UtilityService } from '../../../core/services/utility.service';

@Component({
  selector: 'tt-travel-wage-data',
  templateUrl: './travel-wage-data.component.html',
  styleUrls: ['./travel-wage-data.component.css']
})
export class TravelWageDataComponent implements OnInit {
    travelBillNo;

    travelWageDataKeyno;

    public edit?: Edit;

    public selectListTravelWageTypes: TravelWageTypeItem[] = [];

    public selectListTravelWages: TravelWageItem[] = [];

    public saving = false;

    public travelWageButtons: FormButton[] = [{ id: 'list', type: 'primary', icon: 'fas fa-bars', goto: 'travelwages' }];

    public travelWageButtonsExpanded: FormButton[] = [
        { id: 'list', type: 'primary', icon: 'fas fa-bars', goto: 'travelwages' },
        { id: 'goto', type: 'primary', icon: 'fas fa-chevron-right', goto: 'travelwagemenu', gotoParms: () => this.edit!.travelwage_id ?? '' }
    ];

    constructor(private stateService: StateService, private utility: UtilityService, private modal: ModalService, private datatask: DataTaskService) {
        this.travelBillNo = this.stateService.getStateParams()['travelbill_no'];
        this.travelWageDataKeyno = this.stateService.getStateParams()['travelwagedata_keyno'];
    }

    private async loadEdit() {
        if (!!this.travelBillNo && !!this.travelWageDataKeyno) {
            this.edit = (await this.datatask.Post(1259, {
                travelbill_no: this.travelBillNo,
                travelwagedata_keyno: this.travelWageDataKeyno
            }))[0];
        }
    }

    private async loadTravelWageTypes() {
        this.selectListTravelWageTypes = await this.datatask.Post(1261);
    }

    private async loadTravelWages() {
        if (!this.edit) return;

        this.selectListTravelWages = await this.datatask.Post(1260, {
            travelbill_no: this.edit.travelbill_no,
            travelwagedata_keyno: this.edit.travelwagedata_keyno,
            travelwagetype_id: this.edit.travelwagetype_id
        });
    }

    private async changeTravelWage() {
        if (!this.edit) return;

        const response = (await this.datatask.Post(1263, this.edit))[0];

        this.edit.rate = response.rate;

        this.recalcAmount();
    }

    private recalcAmount() {
        if (!this.edit) return;

        this.edit.amount = this.utility.parseNumber(this.edit.number) * this.utility.parseNumber(this.edit.rate);
    }

    public async saveChanges() {
        if (!!this.edit) {
            try {
                this.saving = true;

                const response = (await this.datatask.Post(1262, this.edit))[0];

                if (response?.errorcode !== '0') {
                    this.modal.show({
                        type: 'warning',
                        title: 'error',
                        translateTitle: true,
                        message: response.errormessage
                    });
                } else {
                    this.stateService.back();
                }
            } finally {
                this.saving = false;
            }
        }
    }

    public onChanged(_: string, id: keyof Edit) {
        if (!this.edit) return;

        switch (id) {
            case 'travelwagetype_id':
                this.loadTravelWages();

                this.edit.travelwage_id = '';
                this.edit.rate = '0';
                this.edit.amount = '0';
                break;
            case 'travelwage_id':
                this.changeTravelWage();
                break;
            case 'number':
                this.recalcAmount();
                break;
            default:
                break;
        }
    }

    private async init() {
        await this.loadEdit();
        this.loadTravelWageTypes();
        this.loadTravelWages();
    }

    ngOnInit() {
        this.init();
    }
}

interface Edit {
    travelbill_no: string;
    travelwagedata_keyno: string;
    travelwage_id: string;
    fromdate: string;
    tomdate: string;
    number: string;
    amount: string | number;
    rate: string;
    note: string;
    travelwagetype_id: string;
    travelwageadmin: string;
}

interface TravelWageTypeItem {
    travelwagetype_id: string;
    travelwagetype_name: string;
    orderby: number;
}

interface TravelWageItem {
    travelwage_id: string;
    travelwage_name: string;
    orderby: number;
}
